import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { SectionHeader, Panel, FieldRow } from "@/components/admin/common";

const FIELDS = [
  ["chip", "Top chip (location)"],
  ["eyebrow", "Eyebrow text"],
  ["headline_line1", "Headline — line 1"],
  ["headline_line2_italic", "Headline — italic line"],
  ["headline_line3_red", "Headline — red accent word"],
  ["headline_line4", "Headline — last word"],
  ["tagline_th", "Thai tagline"],
  ["cta_primary_label", "Primary CTA label"],
  ["price_tag", "Price tag (From £…)"],
  ["today_caption", "Today caption (photo overlay)"],
  ["hours_chip_number", "Hours chip — big number"],
  ["hours_chip_sub", "Hours chip — small caption"],
];

export default function AdminHero({ value, onChange, onSave, onReset, saving }) {
  const v = value || {};
  const update = (k, val) => onChange({ ...v, [k]: val });

  return (
    <div>
      <SectionHeader
        title="Hero section"
        description="Edit the text at the very top of the site."
        onSave={() => onSave(v)}
        onReset={onReset}
        saving={saving}
      />
      <Panel>
        <FieldRow>
          {FIELDS.map(([key, label]) => (
            <div key={key}>
              <Label>{label}</Label>
              <Input
                data-testid={`admin-hero-${key}`}
                value={v[key] || ""}
                onChange={(e) => update(key, e.target.value)}
                className="h-11 rounded-xl mt-1"
              />
            </div>
          ))}
        </FieldRow>
        <div className="mt-5">
          <Label>Sub-headline paragraph</Label>
          <Textarea
            data-testid="admin-hero-subhead"
            value={v.subhead || ""}
            onChange={(e) => update("subhead", e.target.value)}
            rows={3}
            className="rounded-xl mt-1"
          />
        </div>
      </Panel>
    </div>
  );
}
